// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../styles/helpers.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon_close--gray.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
  cursor: pointer;
}

.styles__button___M97PM {
}

.styles__contentContainer___OAHVk {
  display: flex;
  flex-flow: row wrap;
  padding-bottom: 20px;
  padding-top: 20px;
}

.styles__contentContainer___OAHVk:before {
  content: '';
  display: table;
}

.styles__contentContainer___OAHVk:after {
  content: '';
  display: table;
  clear: both;
}

.styles__form___HPgNE {
  display: flex;
  flex-flow: column nowrap;
}

.styles__formItemMono___xL73G {
}

.styles__formWrapper___veHVE {
  width: calc(99.9% * 2/3 - (30px - 30px * 2/3));
}

.styles__formWrapper___veHVE:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__formWrapper___veHVE:last-child {
  margin-right: 0;
}

.styles__formWrapper___veHVE:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__formWrapper___veHVE:nth-child(3n + 1) {
  clear: both;
}

.styles__headerSection___lhq6z {
  min-height: 80px;
}

.styles__headerTitle___oOw32 {
  float: left;
}

.styles__link___nK7oq {
  background: rgba(255, 255, 255, 0.7);
  box-shadow: none;
  display: block;
}

.styles__link___nK7oq:hover {
    background: white;
    box-shadow: none;
  }

.styles__menuLink___p3QrN {
  color: gtGreen;
  display: flex;
  align-self: center;
}

.styles__menuWrapper___GxYxA {
  width: calc(99.9% * 1/3 - (30px - 30px * 1/3));
}

.styles__menuWrapper___GxYxA:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__menuWrapper___GxYxA:last-child {
  margin-right: 0;
}

.styles__menuWrapper___GxYxA:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__menuWrapper___GxYxA:nth-child(3n + 1) {
  clear: both;
}

.styles__navigationMenuWrapper___qeIPf {
  position: fixed;
  width: 452.86px;
}

@media (max-width: 1440px) {

.styles__navigationMenuWrapper___qeIPf {
    max-width: 31%;
    right: 20px;
}
  }

.styles__row___1ch_e {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.styles__section___hb7QC {
}

.styles__sectionTitle___GS745 {
}

.styles__titleSection___rVrTO {
  position: relative;
}

.styles__titleSection___rVrTO:last-child {
    margin-bottom: 20px;
  }

.styles__titleSection___rVrTO .styles__name___V4oto {
    font-size: 18px;
    transition: all 0.25s;
  }

.styles__titleSection___rVrTO .styles__noName___D7njM {
    margin-top: 2px;
  }

.styles__sectionNoMargin___CoOBS {
}

.styles__accountExtrasSection___iLwZY {
  padding: 0;
}

.styles__formItemMono___xL73G {
}

.styles__input____YVK0 {
}

.styles__label___jIeD5 {
}

.styles__emailGroup___XYwx5 .styles__input____YVK0 {
  float: left;
  width: 50%;
}

.styles__emailGroup___XYwx5 .styles__label___jIeD5 {
  font-size: 15px;
  float: right;
  width: 45%;
  margin-top: 10px;
}

.styles__remove___kNp2R {
  height: 20px;
  width: 20px;
  background-position: center;
  background-size: 14px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  cursor: pointer;
  transition: opacity 0.2s;
}

.styles__remove___kNp2R a {
    display: block;
    box-shadow: none;
    height: 20px;
    width: 20px;
  }
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/CoTrustee/components/User/components/Main/styles.css"],"names":[],"mappings":"AAEA;EACE,eAAe;AACjB;;AAEA;AAEA;;AAEA;EAEE,aAAwB;EAAxB,mBAAwB;EAExB,oBAAoB;EACpB,iBAAiB;AACnB;;AANA;EAGE,WAAsB;EAAtB,cAAsB;AAGxB;;AANA;EAGE,WAAsB;EAAtB,cAAsB;EAAtB,WAAsB;AAGxB;;AAEA;EACE,aAA2B;EAA3B,wBAA2B;AAC7B;;AAEA;AAEA;;AAEA;EACE,8CAAgB;AAClB;;AAFA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAClB;;AAFA;EACE,eAAgB;AAClB;;AAFA;EACE,eAAgB;EAAhB,YAAgB;AAClB;;AAFA;EACE,WAAgB;AAClB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAEhB,cAAc;AAMhB;;AAJE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;AAGF;EACE,cAAc;EAEd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,8CAAgB;AAClB;;AAFA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAClB;;AAFA;EACE,eAAgB;AAClB;;AAFA;EACE,eAAgB;EAAhB,YAAgB;AAClB;;AAFA;EACE,WAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AAMjB;;AAJE;;AAJF;IAKI,cAAc;IACd,WAAW;AAEf;EADE;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EAEE,kBAAkB;AAcpB;;AAZE;IACE,mBAAmB;EACrB;;AAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;AAEA;IACE,eAAe;EACjB;;AAGF;AAEA;;AAEA;EAEE,UAAU;AACZ;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,qBAAqB;EACrB,4BAA4B;EAC5B,yDAAwD;EACxD,eAAe;EACf,wBAAwB;AAQ1B;;AANE;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb","sourcesContent":["@value helpers: \"styles/helpers.css\";\n\na {\n  cursor: pointer;\n}\n\n.button {\n  composes: button from helpers;\n}\n\n.contentContainer {\n  composes: content-container from helpers;\n  lost-flex-container: row;\n  lost-utility: clearfix;\n  padding-bottom: 20px;\n  padding-top: 20px;\n}\n\n.form {\n  lost-flex-container: column;\n}\n\n.formItemMono {\n  composes: formItemMono from helpers;\n}\n\n.formWrapper {\n  lost-column: 2/3;\n}\n\n.headerSection {\n  composes: section from helpers;\n  min-height: 80px;\n}\n\n.headerTitle {\n  float: left;\n}\n\n.link {\n  background: rgba(255, 255, 255, 0.7);\n  box-shadow: none;\n  composes: sectionTitle from helpers;\n  display: block;\n\n  &:hover {\n    background: white;\n    box-shadow: none;\n  }\n}\n\n.menuLink {\n  color: gtGreen;\n  composes: link;\n  display: flex;\n  align-self: center;\n}\n\n.menuWrapper {\n  lost-column: 1/3;\n}\n\n.navigationMenuWrapper {\n  position: fixed;\n  width: 452.86px;\n\n  @media (max-width: 1440px) {\n    max-width: 31%;\n    right: 20px;\n  }\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n\n.section {\n  composes: section from helpers;\n}\n\n.sectionTitle {\n  composes: sectionTitle from helpers;\n}\n\n.titleSection {\n  composes: sectionTitle row from helpers;\n  position: relative;\n\n  &:last-child {\n    margin-bottom: 20px;\n  }\n\n  .name {\n    font-size: 18px;\n    transition: all 0.25s;\n  }\n\n  .noName {\n    margin-top: 2px;\n  }\n}\n\n.sectionNoMargin {\n  composes: sectionNoMargin from helpers;\n}\n\n.accountExtrasSection {\n  composes: sectionNoMargin;\n  padding: 0;\n}\n\n.formItemMono {\n  composes: formItemMono from helpers;\n}\n\n.input {\n  composes: input from helpers;\n}\n\n.label {\n  composes: label from helpers;\n}\n\n.emailGroup .input {\n  float: left;\n  width: 50%;\n}\n\n.emailGroup .label {\n  font-size: 15px;\n  float: right;\n  width: 45%;\n  margin-top: 10px;\n}\n\n.remove {\n  height: 20px;\n  width: 20px;\n  background-position: center;\n  background-size: 14px;\n  background-repeat: no-repeat;\n  background-image: url(\"styles/img/icon_close--gray.png\");\n  cursor: pointer;\n  transition: opacity 0.2s;\n\n  a {\n    display: block;\n    box-shadow: none;\n    height: 20px;\n    width: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"button": `styles__button___M97PM ${___CSS_LOADER_ICSS_IMPORT_0___.locals["button"]}`,
	"contentContainer": `styles__contentContainer___OAHVk ${___CSS_LOADER_ICSS_IMPORT_0___.locals["content-container"]}`,
	"form": `styles__form___HPgNE`,
	"formItemMono": `styles__formItemMono___xL73G ${___CSS_LOADER_ICSS_IMPORT_0___.locals["formItemMono"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["formItemMono"]}`,
	"formWrapper": `styles__formWrapper___veHVE`,
	"headerSection": `styles__headerSection___lhq6z ${___CSS_LOADER_ICSS_IMPORT_0___.locals["section"]}`,
	"headerTitle": `styles__headerTitle___oOw32`,
	"link": `styles__link___nK7oq ${___CSS_LOADER_ICSS_IMPORT_0___.locals["sectionTitle"]}`,
	"menuLink": `styles__menuLink___p3QrN styles__link___nK7oq ${___CSS_LOADER_ICSS_IMPORT_0___.locals["sectionTitle"]}`,
	"menuWrapper": `styles__menuWrapper___GxYxA`,
	"navigationMenuWrapper": `styles__navigationMenuWrapper___qeIPf`,
	"row": `styles__row___1ch_e`,
	"section": `styles__section___hb7QC ${___CSS_LOADER_ICSS_IMPORT_0___.locals["section"]}`,
	"sectionTitle": `styles__sectionTitle___GS745 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["sectionTitle"]}`,
	"titleSection": `styles__titleSection___rVrTO ${___CSS_LOADER_ICSS_IMPORT_0___.locals["sectionTitle"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["row"]}`,
	"name": `styles__name___V4oto`,
	"noName": `styles__noName___D7njM`,
	"sectionNoMargin": `styles__sectionNoMargin___CoOBS ${___CSS_LOADER_ICSS_IMPORT_0___.locals["sectionNoMargin"]}`,
	"accountExtrasSection": `styles__accountExtrasSection___iLwZY styles__sectionNoMargin___CoOBS ${___CSS_LOADER_ICSS_IMPORT_0___.locals["sectionNoMargin"]}`,
	"input": `styles__input____YVK0 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["input"]}`,
	"label": `styles__label___jIeD5 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["label"]}`,
	"emailGroup": `styles__emailGroup___XYwx5`,
	"remove": `styles__remove___kNp2R`
};
export default ___CSS_LOADER_EXPORT___;
